import { FinanceAccountManageCardMainContainer } from '../../../containers';

export const FinanceAccountManageCard = () => {
  return <FinanceAccountManageCardMainContainer />;
};
